import React from 'react'
import {
  Wrapper,
  Content,
  CheckIconLayerOne,
  CheckIconLayerTwo,
  BoldText,
  BoldMuteText,
  MuteText,
} from 'modules/Students/Partials/StudentsBulkUpload/Partials/StatusMessage/Style/style'
import CheckIcon from 'components/icons/CheckIcon'
import { COLORS } from 'theme'

const StatusMessage = () => {
  return (
    <Wrapper>
      <Content>
        <CheckIconLayerTwo>
          <CheckIconLayerOne>
            <CheckIcon color={COLORS.WHITE} />
          </CheckIconLayerOne>
        </CheckIconLayerTwo>
        <BoldText>Bulk Files Successfully Uploaded</BoldText>
        <div>
          <BoldMuteText>Student.xsl & Student 2.csv</BoldMuteText>
          <MuteText>file has been successfully uploaded</MuteText>
        </div>
      </Content>
    </Wrapper>
  )
}

export default StatusMessage
